import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class FileuploadService {

  constructor(private httpClient:HttpClient) { }

  backendUrl = environment.apiURL;
  private base64ImageData: string | null = null;

  upload(file : File) : Observable<any> {
    console.log(file);
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('agentportal', 'true');
    console.log(formData.get('file'));
    return this.httpClient.post(this.backendUrl + 'uploadFiles', formData, { responseType: 'text' as 'json' } ).pipe(retry(2), catchError(this.handleError));

  }
  // base64Fileupload() : Observable<any> {
  //   const formData: FormData = new FormData();
  //   formData.append('agentportal', 'true');

  //   const base64ImageData = this.getBase64ImageData();
  //   console.log('Base64 Image Data:', base64ImageData);
  //   if (base64ImageData) {
  //     formData.append('base64Image', base64ImageData);
  //   }
  //   console.log(formData.get('base64Image'));
  //   return this.httpClient.post(this.backendUrl + 'uploadFiles', formData, { responseType: 'text' as 'json' } ).pipe(retry(2), catchError(this.handleError));
  // }

  getMyUploads() : Observable<any> {
    const formData: FormData = new FormData();
    return this.httpClient.get(this.backendUrl + 'getMyUploads', httpOptions).pipe(retry(2), catchError(this.handleError));
  }

  // setBase64ImageData(base64Data: string): void {
  //   this.base64ImageData = base64Data;
  //   console.log("Base64 Data set in service:", this.base64ImageData);
  // }
  // getBase64ImageData(): string | null {
  //   return this.base64ImageData;
  // }
  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }
}
